import axios from "axios"
import { EmployeeWorkedSitesForDurationInterface, EmployeeWorkHistoryInterface } from "@type/employees.types"
const ROOT_PATH = "employees/work-history"

export default class EmployeesWorkHistoryService {
	static getEmployeeWorkHistoryByEmployeeID = (employeeId: string) =>
		axios.get<EmployeeWorkHistoryInterface[]>(`${ROOT_PATH}/${employeeId}`)

	static getEmployeeWorkedSitesForDuration = (employeeId: string, startDate: string, endDate: string) =>
		axios.get<EmployeeWorkedSitesForDurationInterface[]>(`${ROOT_PATH}/sites/for-duration/${employeeId}`, {
			params: {
				startDate,
				endDate,
			},
		})
}
